import React from "react";
import { useLocation } from "react-router-dom";

class AnimateLoading extends React.Component {
  animateTimeout;
  stopAnimateTimeout;
  state = {
    width: 0,
    routeChanged: false
  };

  componentDidUpdate(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.animate();
    }
  }

  animate() {
    this.animateTimeout = setTimeout(() => {
      if (this.state.width <= 100) {
        this.setState({ width: this.state.width + 10 });
        this.animate();
      } else {
        this.stopAnimate();
      }
    }, 30);
  }
  stopAnimate() {
    clearTimeout(this.animateInterval);
    this.stopAnimateTimeout = setTimeout(() => {
      this.setState({ width: 0 });
    }, 300);
  }
  componentWillUnmount() {
    if (this.stopAnimateTimeout) {
      clearTimeout(this.stopAnimateTimeout);
    }
    if (this.animateTimeout) {
      clearTimeout(this.animateTimeout);
    }
  }
  render() {
    return (
      <div
        className="header-progress-bar"
        style={{
          height: "3px",
          width: "100%",
          backgroundColor: "#f0f0f0",
          position: "relative"
        }}
      >
        {this.state.width > 0 && (
          <div
            style={{
              height: "3px",
              width: `${this.state.width}%`,
              backgroundColor: "#007bff",
              transition: "width 0.3s ease",
              position: "absolute",
              top: 0,
              left: 0
            }}
          />
        )}
      </div>
    );
  }
}

const ConnectedAnimateLoading = AnimateLoading;

export default function AnimateLoadingWrapper(props) {
  const location = useLocation();
  return <ConnectedAnimateLoading {...props} location={location} />;
}
